/* eslint react-hooks/rules-of-hooks: "error", react-hooks/exhaustive-deps: "error" */
import React, { useEffect, useMemo } from "react";

import { useAppContext } from "../../../../lib/appContext";
import { dispatch, types } from "../../../quoteForms/state";
import { SocketContext } from "./context";
import { SocketQuoteForm } from "./socket";
import {
  IQuoteFormValues,
  IResponseQuoteForm,
  SocketResponse,
  OfferSelectedParams,
  OfferSelectedResponse,
  GetOfferResponse
} from "./types";

const { Provider } = SocketContext;

const SocketContextProvider: React.FC = ({ children }) => {
  const Socket = useMemo(() => new SocketQuoteForm(), []);
  const { countryCode, businessUnitConfig } = useAppContext();
  const businessUnit = {
    countryCode,
    businessUnit: businessUnitConfig.businessUnit
  };

  useEffect(() => {
    return () => Socket.disconnect();
  }, [Socket]);

  const onResponseSaveQuote = (responseSaveQuoteForm?: SocketResponse) => (
    response: IResponseQuoteForm
  ) => {
    dispatch({ type: types.RESPONSE_SAVE_QUOTE_FORM, form: response.form });
    if (responseSaveQuoteForm) {
      responseSaveQuoteForm(response);
    }
  };

  const onResponseQuoteForm = (responseGetQuoteFormById?: SocketResponse) => (
    response: IResponseQuoteForm
  ) => {
    dispatch({
      form: response.status ? response.form : {},
      type: types.RESPONSE_GET_QUOTE_FORM
    });
    if (responseGetQuoteFormById && response.status) {
      responseGetQuoteFormById(response);
    }
  };

  const saveQuoteForm = (form: IQuoteFormValues, responseSaveQuoteForm?: SocketResponse) => {
    dispatch({ type: types.SAVE_QUOTE_FORM });
    Socket.saveQuoteForm(form, businessUnit, onResponseSaveQuote(responseSaveQuoteForm));
  };

  const getQuoteFormById = (formId: string, responseGetQuoteFormById?: SocketResponse) => {
    dispatch({ type: types.GET_QUOTE_FORM_BY_ID, formId });
    Socket.getQuoteFormById(formId, businessUnit, onResponseQuoteForm(responseGetQuoteFormById));
  };

  const requoteForm = (formId: string, responseSaveQuoteForm?: SocketResponse) => {
    dispatch({ type: types.SAVE_QUOTE_FORM });
    Socket.requoteForm(formId, businessUnit, onResponseSaveQuote(responseSaveQuoteForm));
  };

  const offerSelected = (
    { formId, offerId, ...params }: OfferSelectedParams,
    responseOfferSelectedProcessed?: OfferSelectedResponse
  ) => {
    dispatch({ type: types.OFFER_SELECTED, formId, offerId, ...params });
    Socket.offerSelected(
      { formId, offerId, ...params },
      businessUnit,
      responseOfferSelectedProcessed
    );
  };

  const getOfferById = (
    offerId: string,
    formId: string,
    responseGetOfferById: GetOfferResponse
  ) => {
    Socket.getOfferById(offerId, formId, businessUnit, responseGetOfferById);
  };

  return (
    <Provider value={{ saveQuoteForm, getQuoteFormById, requoteForm, offerSelected, getOfferById }}>
      {children}
    </Provider>
  );
};

export { SocketContextProvider };
